// Board-only int-backed enums, 1:1 with dotnet/Data/Trillion.Data/Enums/*.cs. The numeric values ARE the
// ids of the matching lookup tables in the board database — change one side, change both. Single-app, so
// these stay app-local; anything a second app consumes moves to @trillion/enums.

export enum TeamRole {
  TeamAdmin = 1,
  TeamMember = 2,
}

// NOT a privilege order — declaration order is the inverse of it (Owner is the *most* privileged yet has
// the lowest id). Never rank by the raw value; rank through the explicit enum-keyed map (the API side's
// DiagramAuthorizationService.RoleHierarchy).
export enum DiagramRole {
  Owner = 1,
  Editor = 2,
  Commenter = 3,
  Viewer = 4,
}

export enum InviteStatus {
  Pending = 1,
  Accepted = 2,
  Declined = 3,
  Expired = 4,
  Cancelled = 5,
}

export enum AccessRequestStatus {
  Pending = 1,
  Approved = 2,
  Denied = 3,
}
